import { Link, usePage } from "@inertiajs/react";
import type { Item } from "@/interfaces/item";
import type { SharedProps } from "@/types";
import Badge from "@/components/ui/Badge";
import Button from "@/components/ui/Button";

export default function ReferralItem({ item }: { item: Item }) {
  const { props } = usePage<SharedProps>();
  const idvVerified = props.user.verification_status === "verified";

  return (
    <div className="border-goldenrod bg-sidecar/40 shadow-card border-2 p-5">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        {item.image && (
          <img
            src={item.image}
            alt={item.name}
            className="border-line bg-surface-plain h-24 w-24 shrink-0 border-2 object-contain"
          />
        )}

        <div className="flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <h2 className="font-display text-subheading text-ink font-bold">
              🎁 {item.name}
            </h2>
            <Badge tone="brand">FREE</Badge>
          </div>
          <p className="text-body text-ink-muted mt-1">{item.description}</p>
          <p className="text-caption text-ink-soft mt-1">
            You were referred - claim this item for free!
          </p>
        </div>

        {idvVerified ? (
          <Link
            href={`/shop/${item.id}/claim_referral_item`}
            method="post"
            as="button"
            className="border-line font-display text-ink-muted shadow-control duration-fast ease-standard shrink-0 cursor-pointer border-2 bg-[linear-gradient(180deg,#c0dfc6_0%,#85c5da_44%,#6fbbe2_81%,#b6dbc9_100%)] px-6 py-2.5 font-bold transition-all hover:-translate-y-px active:translate-y-0.5 active:shadow-none"
          >
            Claim free
          </Link>
        ) : (
          <Button variant="secondary" disabled className="shrink-0">
            Verify to claim
          </Button>
        )}
      </div>
    </div>
  );
}
